import { barkApi } from '@bark/bark-core/src/components/legacy-scripts/barklib';

export const getPaymentMethods = async (sellerProfileId) => {
	try {
		const { data } = await barkApi(`seller/${sellerProfileId}/payment-methods`);
		return data;
	} catch (e) {
		console.error(e);
		bugsnagClient.notify(new Error('Failed to get payment methods'), {
			metaData: { original: e, errText: String(e) },
		});

		return false;
	}
};

export const getPrimaryPaymentMethod = async (sellerProfileId) => {
	const paymentMethods = await getPaymentMethods(sellerProfileId);
	// Primary is currently defined as the first record, and currently only one item is ever returned
	let primary = paymentMethods?.length ? paymentMethods[0] : false;

	if (!primary?.card_number || !primary?.card_brand_image) {
		// The format of the primary card is invalid
		primary = false;
	}

	return primary;
};

export const exportPaymentMethodsToWindow = () => {
	window.getPaymentMethods = getPaymentMethods;
	window.getPrimaryPaymentMethod = getPrimaryPaymentMethod;
};
